/* tslint:disable:no-string-literal */
import { Component, ElementRef, Inject, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import {
    AllDevicesService,
    rangeDate,
    temperatureDetail,
    temperatureDetails
} from '../../../providers/service/all-devices.service';
import {
    aggregateHardawareDetailDevice,
    arrayIsSet,
    cleanToSpecialCharacterAndLowerCaseString,
    DataTypeColor,
    ElementTreeType,
    GlobalVariablesService,
    hunaColors, isMobile,
    isNotNullOrUndefined,
    KeyStringValue, notRepeatValueOperator$,
    objectIsSet,
    ObjectSringNumber,
    peiodicDataElementType,
    sensorDataType,
    stringIsSet
} from '../../../providers/service/global-variables.service';
import { AlertService } from '../../../providers/service/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { ChartService } from '../../../providers/service/chart.service';
import { BehaviorSubject, combineLatest, EMPTY, forkJoin, Observable, of, range, Subscription } from 'rxjs';
import { catchError, expand, filter, map, pairwise, startWith, switchMap, take, takeWhile } from 'rxjs/operators';
import { UntypedFormBuilder } from '@angular/forms';
import { IconService } from '../../../providers/service/icon.service';
import { breakPointType } from '../../../widget/split-screen/split-screen.component';
import { ExportFileService } from '../../../providers/service/export-file.service';
import { ElementTypeParse } from '../../../ParseClass/ElementType.Parse';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FlatTreeControl } from "@angular/cdk/tree";
import { MatTreeFlatDataSource, MatTreeFlattener } from "@angular/material/tree";
import { SensorDataScaleType } from "../../../ParseClass/sensor-data-types-parse";
import { MatTabGroup } from "@angular/material/tabs";
import { PossibleValuesFormField } from "../../../widget/multi-select-form-field/multi-select-form-field.component";


interface ElementNode {
    name: string;
    parentName?: string;
    elementId?: string,
    environment?: string,
    typeId?: string,
    children?: ElementNode[];
}


/** Flat node with expandable and level information */
interface ElementFlatNode {
    expandable: boolean;
    name: string;
    level: number;
}

interface DataTypeDetail {
    elementId: string,
    dataType: string,
    objectId?: string,
    values?: any
}

class PeriodClass {
    value: number;
    measurementValueDate: Date;
    nextMeasurementValueDate: Date;
    initPeriod: Date;
    finishPeriod: Date;

    constructor(value: number, measurementValueDate: Date, nextMeasurementValueDate: Date, initPeriod: Date, finishPeriod: Date) {
        this.value = value
        this.measurementValueDate = measurementValueDate
        this.nextMeasurementValueDate = nextMeasurementValueDate
        this.initPeriod = initPeriod
        this.finishPeriod = finishPeriod
    }

    get weigth() {
        return (this.nextMeasurementValueDate.getTime() - this.measurementValueDate.getTime())
    }

    get weigthedValue() {
        return this.weigth * this.value
    }


}

export type ChipsElementsForm = {
    elementId: string,
    name: string,
    info: { key: string, color: string, selected: boolean, objectId: string }[]
}
export type LeggendItem = {
    label: string,
    borderColor: string,
    backgroundColor: string,
    icon: string,
    objectId: string
}

@Component({
    selector: 'app-chart-data-types',
    templateUrl: './chart-data-types.component.html',
    styleUrls: ['./chart-data-types.component.scss'],
    standalone: false
})
export class ChartDataTypesComponent implements OnInit, OnDestroy {

    @ViewChild('chartTemperatureRef', { static: false }) private chartTemperatureRef: ElementRef | undefined;
    @ViewChildren('NODESCROLLABLE') private nodeScroollable: QueryList<any> | undefined
    @ViewChild('chipsViewport') private chipsViewport: ElementRef<HTMLElement> | undefined;
    public lastChipsScrollTop = 0;
    private selectTabChangeEmit = new BehaviorSubject<any | undefined>({ index: 0 })
    private selectTabChange$ = this.selectTabChangeEmit.asObservable()

    selecTabChange(value: any) {
        this.selectTabChangeEmit.next(value)
    }


    private _chartTemperature: any | undefined;
    get chartTemperature(): any | undefined {
        return this._chartTemperature;
    }

    set chartTemperature(value: any | undefined) {
        this._chartTemperature = value;
    }

    form = this.fb.group({ searchName: undefined, dataType: null, range: null, periodMobileMediaMinute: undefined });
    disableButton = false;
    public diabledButtonWeek = false;
    currentDate$: Observable<rangeDate>
    currentDateEmitOnlyUpdate$: Observable<rangeDate>
    chartTemperaturaData: {
        objectIdInizio?: string,
        objectIdFine: string,
        elementId: string,
        data: temperatureDetails,
        sensorDataType: string
    }[] = [];
    detailsElementsValues: DataTypeDetail[] = [];
    sensorValues: string[] = [sensorDataType.setTemperature, sensorDataType.temperature];
    private lastDate: Date;
    private subscriptions = new Subscription()

    public sensorDataType = sensorDataType;

    public typesData: { traduction: string, icon?: string, svgIcon?: string }[] | undefined;
    public colorsDataTypeEmit: BehaviorSubject<{
        [key: string]: 'orange' | 'yellow' | 'blue' | 'violet'
    }> = new BehaviorSubject<{ [p: string]: "orange" | "yellow" | "blue" | "violet" }>({});
    public colorsDataType$ = this.colorsDataTypeEmit.asObservable();
    public hiddenLegendsEmit = new BehaviorSubject<{
        index: number,
        objectId: string
    }[] | undefined>([]);
    public hiddenLegends$ = this.hiddenLegendsEmit.asObservable();
    public hiddenLegendsIndex$ = this.hiddenLegends$.pipe(
        map(hiddens => {
            if (arrayIsSet(hiddens)) {
                return hiddens.map(h => h.index)
            } else {
                return
            }
        })
    );
    // tslint:disable-next-line:variable-name
    private _deltaDate: ObjectSringNumber = {};
    public changeDate: { [k: string]: rangeDate | undefined } = { temperature: undefined };
    config: any

    public loadDate = false
    deltaDate$: Observable<number | undefined>
    maxMinutePeriodDate: number | undefined = undefined
    step: number = 5

    searchName$: Observable<string>

    private setDate(date: rangeDate, key: string): void {
        let obj;
        if (this.changeDate != null) {
            obj = { ...this.changeDate };
        } else {
            obj = {};
        }
        obj[key] = date;
        this.changeDate = obj;
    }


    private _transformer = (node: ElementNode, level: number) => {
        return {
            expandable: !!node.children && node.children.length > 0,
            name: node.name,
            level: level,
            elementId: node.elementId,
            parentName: node.parentName,
            environment: node.environment,
            children: node.children,
        };
    };

    treeControl = new FlatTreeControl<any>(
        node => node.level,
        node => node.expandable,
    );

    treeFlattener = new MatTreeFlattener(
        this._transformer,
        node => node.level,
        node => node.expandable,
        node => node.children,
    );

    dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    hasChild = (_: number, node: ElementFlatNode) => node.expandable;
    configChartEmit = new BehaviorSubject<any>(undefined)
    configChart$ = this.configChartEmit.asObservable()
    lengthDataset$: Observable<number> = of(100)
    legendChart$: Observable<LeggendItem[] | undefined> = of(undefined)

    getEnvironmentName(el: any) {
        return el == null || el.environment == null ? this.translate.instant('other') : el.environment
    }

    downloadModeIsActive = false
    downloadingFile = { active: false, progress: 0 }
    loadChart = false
    selectedInDownloadMode: DataTypeDetail[] = []
    chipsElemnts$: Observable<ChipsElementsForm[] | undefined>
    dataType$: Observable<{ elementId: string, dataType: string }[] | undefined>

    constructor(
        public dialogRef: MatDialogRef<ChartDataTypesComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            device: aggregateHardawareDetailDevice,
            elements: ElementTreeType[],
            selectElement: ElementTreeType,
            projectName: string,
            elementType: ElementTypeParse,
            title: string | undefined,
            selectSensorData: string[] | undefined,
            range: rangeDate
        },
        private allDevicesService: AllDevicesService,
        private alertService: AlertService,
        private chartService: ChartService,
        private exportFile: ExportFileService,
        private fb: UntypedFormBuilder,
        private globalVariableService: GlobalVariablesService,
        private iconService: IconService,
        private translate: TranslateService,
    ) {
        this.hiddenLegends = []
        const groupLegendIsSet$ = this.selectTabChange$.pipe(
            map(tab => {
                return tab ? tab.index == 0 : false
            })
        )

        const groupSelectionIsSet$ = this.selectTabChange$.pipe(
            map(tab => {
                return tab ? tab.index == 1 : false
            })
        )
        this.searchName$ = this.form.get('searchName')!.valueChanges.pipe(
            startWith(undefined),
            map(() => this.form.get('searchName')!.value),
        )
        this.currentDate$ = this.form.get('range')!.valueChanges.pipe(
            startWith(undefined),
            map(() => this.form.get('range')!.value)
        )
        this.currentDateEmitOnlyUpdate$ = this.currentDate$.pipe(
            pairwise(),
            filter(([prev, current]) => {
                if (prev == null || current == null) {
                    return true
                } else {
                    const getTime = (date: any) => {
                        if (date && date.getTime) {
                            return date.getTime()
                        } else {
                            return null
                        }
                    }
                    const prevFrom = prev.fromDate
                    const prevTo = prev.toDate
                    const currFrom = current.fromDate
                    const currTo = current.toDate
                    return getTime(prevFrom) != getTime(currFrom) || getTime(prevTo) != getTime(currTo)
                }
            }),
            map(([prev, current]) => current)
        )
        this.dataType$ = this.form.get('dataType')!.valueChanges.pipe(
            startWith(undefined),
            map(() => {
                return this.form.get('dataType')?.value
            })
        )
        if (this.data.device) {
            if (arrayIsSet(this.data.device.sensorDataTypes)) {
                let dataType;
                if (this.data.elementType && this.data.elementType.periodicData != null) {
                    dataType = Object.keys(this.data.elementType.periodicData);
                } else {
                    dataType = this.data.device.sensorDataTypes;
                }
                dataType.sort((keyA, keyB) => {
                    const tradA = this.translate.instant('possibleValuesTypeElement.' + keyA);
                    const tradB = this.translate.instant('possibleValuesTypeElement.' + keyB);
                    return tradA.localeCompare(tradB)
                });
                this.typesData = dataType.map(value => {
                    const periodicElementType = (peiodicDataElementType as any)[value];
                    if (periodicElementType != null && periodicElementType.icon != null) {
                        return {
                            traduction: value,
                            icon: periodicElementType.icon,
                        };
                    } else if (periodicElementType != null && periodicElementType.svgIcon != null) {
                        return {
                            traduction: value,
                            svgIcon: (peiodicDataElementType as any)[value].svgIcon
                        };
                    } else {
                        return { traduction: value };
                    }
                });
                this.iconService.addAllIconFromArray(this.typesData);
                this.clickDataType(this.typesData[0].traduction, false);
            }
            const rangeData$ = this.currentDate$.pipe(
                filter((range) => range != null)
            )
            const dataType$ = this.dataType$.pipe(
                filter((range) => range != null)
            )
            const periodMobileMediaMinute$ = this.form.get('periodMobileMediaMinute')!.valueChanges.pipe(
                startWith(undefined),
                map(() => {
                    return this.form.get('periodMobileMediaMinute')?.value
                }),
            )
            const sub = combineLatest([rangeData$, dataType$, periodMobileMediaMinute$])
                .pipe(
                    switchMap(([rangeData, dataType, periodMobileMediaMinute]) => {
                        this.disableButton = true
                        this.loadDate = true

                        class PeriodClass {
                            value: number;
                            measurementValueDate: Date;
                            nextMeasurementValueDate: Date;
                            initPeriod: Date;
                            finishPeriod: Date;

                            constructor(value: number, measurementValueDate: Date, nextMeasurementValueDate: Date, initPeriod: Date, finishPeriod: Date) {
                                this.value = value
                                this.measurementValueDate = measurementValueDate
                                this.nextMeasurementValueDate = nextMeasurementValueDate
                                this.initPeriod = initPeriod
                                this.finishPeriod = finishPeriod
                            }

                            get weigth() {
                                return (this.nextMeasurementValueDate.getTime() - this.measurementValueDate.getTime())
                            }

                            get weigthedValue() {
                                return this.weigth * this.value
                            }


                        }


                        return this.getDataTypesDetail(this.data.device, rangeData, dataType! as any).pipe(
                            map((detailsData) => {
                                let marginPoints: Date[] | undefined = undefined
                                let detailsDataMediaMobile: typeof detailsData = []
                                // detailsData.map(d => d.data = d.data.slice(0, 20))
                                const maxMinutePeriodDate = detailsData.reduce((max, valuesForDetails) => {
                                    if (valuesForDetails && arrayIsSet(valuesForDetails.data)) {
                                        const initDatePeriod = valuesForDetails.data[0].date
                                        const finishDatePeriod = valuesForDetails.data[valuesForDetails.data.length - 1].date
                                        const diffDate = finishDatePeriod.getTime() - initDatePeriod.getTime()
                                        const maxMinutePeriodDate = Math.round(Math.abs(diffDate) / 1000 / 60 / 5)
                                        if (maxMinutePeriodDate > max) {
                                            max = maxMinutePeriodDate
                                        }
                                    }

                                    return max
                                }, 0)
                                if (periodMobileMediaMinute != null && periodMobileMediaMinute != 0) {

                                    const periodMobileMediaMilliSec = periodMobileMediaMinute * 60 * 1000
                                    detailsData.forEach(valuesForDetails => {
                                        marginPoints = []
                                        const currentDataType = valuesForDetails.dataType
                                        let periods: {
                                            values: PeriodClass[]
                                        }[] = []
                                        if (arrayIsSet(valuesForDetails.data)) {
                                            // let initDatePeriod: any
                                            let lastIndex = 0
                                            let currentPeriod = {
                                                values: [] as any,
                                            }
                                            const correctValueData = valuesForDetails.data
                                                .sort((a, b) => a.date.getTime() - b.date.getTime())
                                                .filter(value => value.date != null && value.value != null)


                                            let initDatePeriod = correctValueData[0].date
                                            const finishDatePeriod = correctValueData[correctValueData.length - 1].date

                                            const diffDate = finishDatePeriod.getTime() - initDatePeriod.getTime()
                                            while (initDatePeriod.getTime() < finishDatePeriod.getTime()) {
                                                marginPoints!.push(initDatePeriod)
                                                const nextPeriod = new Date(initDatePeriod.getTime() + periodMobileMediaMilliSec);
                                                const datesSliceGetTime: number[] = correctValueData
                                                    .slice(lastIndex, correctValueData.length)
                                                    .map(values => values.date.getTime())
                                                let indexTime = datesSliceGetTime.findIndex(date => date >= initDatePeriod.getTime() && date < nextPeriod.getTime())
                                                let lastIndexTime = indexTime
                                                if (indexTime >= 0) {
                                                    lastIndexTime = datesSliceGetTime
                                                        .slice(indexTime + 1, datesSliceGetTime.length)
                                                        .findIndex(date => date >= nextPeriod.getTime())
                                                    if (lastIndexTime >= 0) {
                                                        lastIndexTime += indexTime + 1
                                                    }
                                                }
                                                if (indexTime < 0 && lastIndexTime >= 0) {
                                                    console.log('error')
                                                    console.log('error')
                                                    console.log('error')
                                                    console.log('error')
                                                    console.log('error')
                                                }


                                                if (lastIndexTime < 0 && indexTime >= 0) {
                                                    const valuesInPeriod = correctValueData
                                                        .slice(indexTime + lastIndex, indexTime + lastIndex + 1)
                                                    currentPeriod = {
                                                        values:
                                                            valuesInPeriod
                                                                .map((values, index) => {
                                                                    const nextValues = correctValueData[lastIndex + indexTime + index + 1]
                                                                    let nextMeasurementDate
                                                                    if (nextValues) {
                                                                        nextMeasurementDate = nextValues.date.getTime() > nextPeriod.getTime() ? nextPeriod : nextValues.date
                                                                    } else {
                                                                        nextMeasurementDate = nextPeriod;
                                                                    }
                                                                    const period = new PeriodClass(values.value, values.date, nextMeasurementDate, initDatePeriod, nextPeriod)
                                                                    return period
                                                                })
                                                    }
                                                } else if (indexTime < 0) {
                                                    lastIndexTime = 0
                                                    const c = correctValueData[lastIndex - 1];
                                                    const period = new PeriodClass(c.value, c.date, nextPeriod, initDatePeriod, nextPeriod)
                                                    currentPeriod = {
                                                        values: [period]
                                                    }
                                                } else {

                                                    const valuesInPeriod = correctValueData
                                                        .slice(indexTime + lastIndex, lastIndex + lastIndexTime)
                                                    currentPeriod = {
                                                        values:
                                                            valuesInPeriod
                                                                .map((values, index) => {
                                                                    const nextValues = correctValueData[lastIndex + indexTime + index + 1]

                                                                    let nextMeasurementDate
                                                                    if (nextValues) {
                                                                        nextMeasurementDate = nextValues.date.getTime() > nextPeriod.getTime() ? nextPeriod : nextValues.date
                                                                    } else {
                                                                        nextMeasurementDate = nextPeriod;
                                                                    }
                                                                    const period = new PeriodClass(values.value, values.date, nextMeasurementDate, initDatePeriod, nextPeriod)
                                                                    return period
                                                                })
                                                    }
                                                }

                                                periods.push(currentPeriod)
                                                lastIndex += lastIndexTime
                                                initDatePeriod = nextPeriod
                                            }

                                        }
                                        const mediaData: { value: number, date: Date }[] = []
                                        periods.forEach(period => {
                                            let sumWeight = 0
                                            let sumValuesWeigth = 0
                                            // let sumValues = 0
                                            period.values.forEach((v, index) => {
                                                // sumValues += v.value
                                                sumWeight += v.weigth
                                                sumValuesWeigth += v.weigthedValue
                                            })
                                            let mediaw = sumValuesWeigth / sumWeight
                                            const lastValues = period.values[period.values.length - 1]
                                            // let media = sumValues / period.values.length
                                            mediaData.push({
                                                value: mediaw,
                                                date: new Date(lastValues.initPeriod.getTime() + periodMobileMediaMilliSec / 2)
                                            })

                                            // if (Math.round(mediaw * 100) != Math.round(media * 100)) {
                                            //     console.log('media  ', media)
                                            //     console.log('media w', mediaw)
                                            // }

                                        })

                                        detailsDataMediaMobile.push({
                                            data: mediaData,
                                            dataInizioPeriodo: valuesForDetails.dataInizioPeriodo,
                                            dataFinePeriodo: valuesForDetails.dataFinePeriodo,
                                            dataType: currentDataType
                                        })


                                    })
                                }
                                return {
                                    detailsData,
                                    rangeData,
                                    dataType,
                                    detailsDataMediaMobile,
                                    marginPoints,
                                    maxMinutePeriodDate
                                }
                            })
                        )
                    })
                )
                .subscribe(({
                    rangeData,
                    dataType,
                    detailsData,
                    detailsDataMediaMobile,
                    marginPoints,
                    maxMinutePeriodDate
                }) => {
                    this.lastDate = rangeData.toDate;
                    this.maxMinutePeriodDate = maxMinutePeriodDate;
                    // this.step = maxMinutePeriodDate ? Math.round(maxMinutePeriodDate / 20) : 1;

                    const temperatures: any[] = [];
                    const valuesNotChart = [
                        peiodicDataElementType.ALARM_CODE.key,
                    ];
                    detailsData.forEach((data, index) => {
                        const key = data.dataType;
                        if (key == sensorDataType.temperature || !valuesNotChart.includes(key) && arrayIsSet(data.data) && data.dataType in this.colorDataType) {
                            temperatures.push({ ...data, color: this.colorDataType[data.dataType] });
                        } else {
                            temperatures.push({ ...data, color: 'verdeBlue' });

                        }
                    });
                    if ((temperatures && arrayIsSet(temperatures))) {
                        this.createChartTemperature(temperatures, detailsDataMediaMobile, marginPoints);
                    } else {
                        this.chartTemperature = this.destroyChart(this.chartTemperature);
                        this.alertService.warning(this.translate.instant('noData'));
                    }
                    this.disableButton = false;
                    this.loadDate = false;
                }, error => {
                    this.alertService.error(error.message);
                    console.log(error)
                    this.disableButton = false;
                    this.loadDate = false;
                }, () => {
                    this.loadDate = false
                    this.disableButton = false
                });
            this.subscriptions.add(sub);

            // this.dateChangedTemperature({toDate: this.lastDate, fromDate: this.lastDate});


        }
        this.chipsElemnts$ = combineLatest([groupSelectionIsSet$, this.searchName$]).pipe(
            map(([isSet, searchName]) => {
                const elements = this.data.elements
                if (isSet && arrayIsSet(elements)) {
                    let filteredElements = this.getElementsPredicate(elements)
                    if (stringIsSet(searchName)) {
                        const cleanSearchName = cleanToSpecialCharacterAndLowerCaseString(searchName)
                        filteredElements = filteredElements.reduce((prev, el) => {
                            let block = cleanToSpecialCharacterAndLowerCaseString(el.name).includes(cleanSearchName)
                            if (!block && objectIsSet(el.info)) {
                                const info = el.info.filter(info => {
                                    const infoTrad = this.globalVariableService.instantSensorDataTypeTraduction(info.key, this.translate.currentLang)
                                    const infoTradClean = cleanToSpecialCharacterAndLowerCaseString(infoTrad)
                                    return infoTradClean.includes(searchName)
                                })
                                el.info = info
                                block = el.info.length > 0
                            }
                            if (block) {
                                prev.push(el)
                            }
                            return prev
                        }, [] as ChipsElementsForm[])
                    }
                    return filteredElements
                } else {
                    return undefined
                }
            })
        )

        let alreadyScrolledToSelectElement = false;
        this.subscriptions.add(
            this.chipsElemnts$.subscribe(chips => {
                if (!arrayIsSet(chips)) {
                    return
                }
                if (!alreadyScrolledToSelectElement && this.data.selectElement != null) {
                    const targetId = this.data.selectElement.objectId
                    const exists = chips!.some(c => c.elementId == targetId)
                    if (exists) {
                        alreadyScrolledToSelectElement = true
                        setTimeout(() => {
                            const container = this.chipsViewport?.nativeElement
                            const el = container?.querySelector<HTMLElement>('#chip-' + targetId)
                            if (container && el) {
                                const top = el.offsetTop - (container.clientHeight / 2) + (el.clientHeight / 2)
                                container.scrollTo({ top, behavior: 'smooth' })
                                this.lastChipsScrollTop = container.scrollTop
                            }
                        })
                        return
                    }
                }
                setTimeout(() => {
                    const container = this.chipsViewport?.nativeElement
                    if (container) {
                        container.scrollTo({ top: this.lastChipsScrollTop, behavior: 'auto' })
                    }
                })
            })
        )

        if (arrayIsSet(this.data.elements)) {
            const elements = this.data.elements
            if (this.data.selectElement != null) {
                const index = elements.findIndex(el => el.objectId == this.data.selectElement.objectId)
                if (index >= 0) {
                    elements.splice(index, 1)
                }
                elements.unshift(this.data.selectElement)
            }
            this.dataSource.data = elements
                .sort((prev, current) => {
                    const prevEnvironment = this.getEnvironmentName(prev)
                    const currentEnvironment = this.getEnvironmentName(current)
                    return prevEnvironment.localeCompare(currentEnvironment)
                })
                .reduce((prev, el, index) => {
                    if (arrayIsSet(el.recentSensorData)) {
                        const lastElement = prev[prev.length - 1]
                        const prevEnvironment = this.getEnvironmentName(lastElement)
                        const currentEnvironment = this.getEnvironmentName(el)
                        if (prev.length == 0 || prevEnvironment != currentEnvironment) {
                            prev.push(
                                {
                                    environment: currentEnvironment,
                                    name: currentEnvironment,
                                    children: []
                                }
                            )
                        }
                        const infoChildren: ElementNode[] = el.recentSensorData.map((values) => {
                            const key = values.type
                            return {
                                parentName: el.name,
                                name: key,
                                typeId: key,
                                elementId: el.objectId,
                                environment: currentEnvironment
                            }
                        }
                        )
                        const elementChildren = {
                            name: el.name,
                            elementId: el.objectId,
                            children: infoChildren,
                            environment: currentEnvironment
                        }
                        prev[prev.length - 1]!.children!.push(elementChildren)
                    }

                    if (index == elements.length - 1) {
                        if (prev.length == 1) {
                            return prev[0].children!
                        }
                    }

                    return prev
                }, [] as ElementNode[]);
            if (this.data.selectElement != null) {
                const dataNodeEnv = this.treeControl.dataNodes.find(el => this.getEnvironmentName(el) == this.getEnvironmentName(this.data.selectElement))
                if (dataNodeEnv != null) {
                    this.treeControl.expand(dataNodeEnv)
                }
                const dataNode = this.treeControl.dataNodes.find(el => el.elementId == this.data.selectElement.objectId)
                if (dataNode != null) {
                    this.treeControl.expand(dataNode)
                }
                setTimeout(() => {
                    const nodeOpened = this.nodeScroollable?.find(nodeList => {
                        return nodeList.nativeElement.id == this.data.selectElement.objectId
                    })
                    if (nodeOpened != null) {
                        nodeOpened.nativeElement.scrollIntoView({
                            behavior: 'auto',
                            block: 'center'
                        });
                    }
                }, 50)
            }
            const dataType$ = this.form.get('dataType')!.valueChanges.pipe(
                startWith(undefined),
                map(() => {
                    return this.form.get('dataType')?.value
                }),
                filter((range) => range != null)
            )
            const periodMobileMediaMinute$ = this.form.get('periodMobileMediaMinute')!.valueChanges.pipe(
                startWith(undefined),
                map(() => {
                    return this.form.get('periodMobileMediaMinute')?.value
                }),
            )
            this.subscriptions.add(
                combineLatest([this.currentDate$, dataType$, periodMobileMediaMinute$]).pipe(
                    switchMap(([rangeDate, dataTypes, periodMobileMediaMinute]) => {
                        this.loadChart = true;
                        if (rangeDate && arrayIsSet(dataTypes)) {
                            return this.getDataTypesDetail_v2(dataTypes as any[], rangeDate).pipe(
                                map((dataDetails) => {
                                    return { dataDetails, rangeDate, dataTypes, periodMobileMediaMinute }
                                })
                            )
                        }
                        return of({ dataDetails: undefined, rangeDate, dataTypes, periodMobileMediaMinute })
                    }),
                    map(({ dataDetails, rangeDate, dataTypes, periodMobileMediaMinute }) => {
                        const valuesToChart = dataDetails?.reduce((prev, detail) => {
                            if (detail.values && detail.values.data && arrayIsSet(detail.values.data)) {
                                const color = this.colorDataType[this.getIdDataType(detail.dataType, detail.elementId)]
                                const element = this.data.elements.find(el => el.objectId === detail.elementId)
                                let name
                                if (element) {
                                    name = element.name
                                }
                                const obj: {
                                    name?: string,
                                    dataType: string,
                                    data: temperatureDetail[],
                                    uom?: string,
                                    scale?: SensorDataScaleType,
                                    color: 'orange' | 'yellow' | 'blue' | 'violet'
                                } = {
                                    dataType: detail.dataType,
                                    color,
                                    data: detail.values.data,
                                    uom: this.globalVariableService.instantSensorDataTypeUom(detail.dataType, this.translate.currentLang),
                                    scale: this.globalVariableService.instantSensorDataTypeScale(detail.dataType, this.translate.currentLang),
                                    name
                                }
                                if (prev == null) {
                                    prev = []
                                }
                                prev.push(obj)
                            }
                            return prev
                        }, undefined as any)
                        let config
                        if (arrayIsSet(valuesToChart)) {
                            let mediaMobileData
                            if (periodMobileMediaMinute) {
                                mediaMobileData = this.getMediaMobileDetails(valuesToChart as any, periodMobileMediaMinute)
                            }
                            config = this.getChartData(valuesToChart as any, mediaMobileData?.detailsDataMediaMobile!, mediaMobileData?.marginPoints!)
                        }
                        this.loadChart = false;
                        return config
                    })
                ).subscribe(config => {
                    this.configChartEmit.next(config)
                })
            )

            this.legendChart$ = combineLatest([groupLegendIsSet$, this.configChart$, this.hiddenLegends$]).pipe(
                map(([isSet, chart, hiddens]) => {
                    if (isSet && chart && chart.data && arrayIsSet(chart.data.datasets)) {
                        return chart.data.datasets.map((dataset: any, index: number) => {
                            let icon
                            const hiddensIncludes = hiddens && hiddens.some(h => h.index == index)
                            if (dataset.hidden && !(hiddensIncludes)) {
                                icon = 'visibility_off'
                            } else if (dataset.hidden && (hiddensIncludes)) {
                                icon = 'visibility'
                            } else if (!dataset.hidden && (hiddensIncludes)) {
                                icon = 'visibility_off'
                            } else {
                                icon = 'visibility'
                            }
                            const borderColor = dataset.borderColor
                            const backgroundColor = dataset.backgroundColor ? dataset.backgroundColor : borderColor
                            return {
                                borderColor,
                                backgroundColor,
                                label: dataset.label,
                                icon,
                                objectId: dataset.objectId
                            }
                        })

                    } else {
                        return undefined
                    }
                })
            )

            if (this.data.selectElement) {
                if (this.data.selectSensorData) {
                    this.data.selectSensorData.forEach(sensorData => {
                        setTimeout(() => {
                            this.clickDataTypeInElements(sensorData, this.data.selectElement.objectId)
                        })
                    })
                } else {
                    const id = this.data.selectElement.objectId
                    let dataType: string | undefined
                    if (this.data.selectElement && arrayIsSet(this.data.selectElement.recentSensorData)) {
                        dataType = this.data.selectElement.recentSensorData[0].type
                    }
                    if (dataType) {
                        setTimeout(() => {
                            this.clickDataTypeInElements(dataType, id)
                        })
                    }
                }
            }

        }
        // const a = {
        //      dataType:"IS_OPEN",
        //      elementId:"YizH5CPUgv",
        //      fromDate: 1696543200000,1697752800000
        //      progettoId:"NCpKydtcWH",
        //      toDate:1698879599000,1699138799000
        //  }
        this.lastDate = new Date();

        if (this.data.range) {
            this.form.get('range')!.setValue(this.data.range)
        } else {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const fromDate = new Date(today.getTime());
            fromDate.setDate(today.getDate() - 1);
            const toDate = new Date(today.getTime());
            toDate.setHours(23, 59, 59, 0)
            this.form.get('range')!.setValue({ fromDate, toDate })
        }
        const range$ = this.form.get('range')!.valueChanges.pipe(
            startWith(undefined),
            map(() => this.form.get('range')!.value)
        )
        this.deltaDate$ = range$.pipe(
            map(rangeDate => {
                if (rangeDate != null && rangeDate.fromDate && rangeDate.toDate) {
                    const fromDateTime = rangeDate.fromDate.getTime()
                    const toDateTime = rangeDate.toDate.getTime()
                    const millisecInDay = 1 * 24 * 3600 * 1000;
                    const deltDate = fromDateTime - toDateTime;
                    return Math.abs(Math.round(deltDate / millisecInDay));
                } else {
                    return undefined
                }
            })
        )


    }


    destroyChart(chart: any | undefined): any | undefined {
        if (chart != null) {
            chart.destroy();
            chart = undefined;
        }
        return chart;
    }

    ngOnInit(): void {


    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe()
    }

    get colorDataType() {
        return this.colorsDataTypeEmit.value
    }

    set colorDataType(value) {
        this.colorsDataTypeEmit.next(value)
    }

    get hiddenLegends() {
        return this.hiddenLegendsEmit.value
    }

    set hiddenLegends(value) {
        this.hiddenLegendsEmit.next(value)
    }

    dateChangedTemperature(event: rangeDate): void {
        if (event.fromDate != null && event.toDate != null) {
            this.setDeltaDateHourlyCurve(event);
            this.form.get('range')?.setValue(event);
        }
    }

    getObjectId(date: rangeDate): string {
        const fromDate = new Date(date.fromDate.getTime());
        fromDate.setHours(0, 0, 0, 0);
        const toDate = new Date(date.toDate.getTime());
        toDate.setHours(0, 0, 0, 0);
        return fromDate.getTime().toString(16) + toDate.getTime().toString(16);
    }

    getDataTypeDetail(device: aggregateHardawareDetailDevice, range: rangeDate, dataType: string): Observable<{
        dataFinePeriodo: Date;
        data: temperatureDetail[];
        dataInizioPeriodo: Date;
        dataType: string
    }> {
        const idFine = this.getObjectId(range);
        const index = this.chartTemperaturaData.findIndex(storedChart => storedChart.objectIdFine == idFine && storedChart.sensorDataType == dataType);
        if (index >= 0) {
            return of({ dataType, ...this.chartTemperaturaData[index].data });
        } else {
            return this.allDevicesService.getDetailTemperature(device.elementId, range.fromDate.getTime(), range.toDate.getTime(), dataType)
                .pipe(
                    map((data) => {
                        const elementId = device.elementId;
                        this.chartTemperaturaData.push({
                            objectIdFine: idFine,
                            elementId,
                            data,
                            sensorDataType: dataType
                        });
                        return { dataType, ...data };
                    }));
        }
    }

    getDataTypesDetail(device: aggregateHardawareDetailDevice, range: rangeDate, dataTypes: string[]): Observable<{
        dataFinePeriodo: Date;
        data: temperatureDetail[];
        dataInizioPeriodo: Date;
        dataType: string
    }[]> {
        const obs: Observable<{
            dataFinePeriodo: Date;
            data: temperatureDetail[];
            dataInizioPeriodo: Date;
            dataType: string
        }>[] = dataTypes
            .map(dataType => this.getDataTypeDetail(device, range, dataType));
        return forkJoin(obs);
    }

    getDataTypeDetail_v2(elementId: string, dataType: string, range: rangeDate,): Observable<DataTypeDetail> {
        const idFine = this.getObjectId(range);
        const index = this.detailsElementsValues.findIndex(storedChart => storedChart.objectId == idFine && storedChart.elementId == elementId && storedChart.dataType == dataType);
        if (index >= 0) {
            return of(this.detailsElementsValues[index]);
        } else {
            return this.allDevicesService.getDetailTemperature(elementId, range.fromDate.getTime(), range.toDate.getTime(), dataType)
                .pipe(
                    map((values) => {
                        const obj: DataTypeDetail = {
                            objectId: idFine,
                            elementId,
                            values,
                            dataType
                        }
                        this.detailsElementsValues.push(obj);
                        return obj;
                    }));
        }
    }

    getDataTypesDetail_v2(values: DataTypeDetail[], range: rangeDate): Observable<DataTypeDetail[]> {
        const obs: Observable<DataTypeDetail>[] = values
            .map(value => this.getDataTypeDetail_v2(value.elementId, value.dataType, range));
        return forkJoin(obs);
    }


    createChartTemperature(temperatureDetails: {
        dataType: string,
        data: temperatureDetail[],
        color: 'orange' | 'yellow' | 'blue' | 'violet'
    }[], detailsDataMediaMobile: any[], periodLine: Date[] | undefined): void {
        let min;
        let max;
        let xAxes;
        const dataSet: any[] = [];
        let maxValue = 0
        temperatureDetails.forEach((temperatureDetail, index) => {
            const dataChart: { x: Date, y: number | undefined }[] = [];
            const dataType = temperatureDetail.dataType;

            const color = temperatureDetail.color;
            if (isNotNullOrUndefined(temperatureDetail)) {

                temperatureDetail.data.forEach(
                    temp => {
                        if (temp.value > maxValue) {
                            maxValue = temp.value
                        }
                        if (isNotNullOrUndefined(temp) && isNotNullOrUndefined(temp.value) && isNotNullOrUndefined(temp.date)) {
                            dataChart.push({ x: temp.date, y: temp.value });
                        }

                    }
                );
            }


            if (dataChart.length == 0) {
                const day = new Date();
                day.setHours(0, 0, 0, 0);
                min = day.getTime();
                day.setDate(day.getDate() + 1);
                day.setMilliseconds(-1);
                max = day.getTime();
                xAxes = { min, max, stepSize: 1, type: 'time' };

            }


            if (arrayIsSet(dataChart)) {
                let traduction = this.globalVariableService.instantSensorDataTypeTraduction(dataType, this.translate.currentLang)
                const unitMeasure = this.globalVariableService.instantSensorDataTypeUom(dataType, this.translate.currentLang)
                if (!stringIsSet(traduction)) {
                    traduction = ''
                }
                if (stringIsSet(unitMeasure)) {
                    (traduction as string) += ' ' + unitMeasure
                }
                const hunaColor = hunaColors[color];
                const indexDetailsDataMediaMobile = arrayIsSet(detailsDataMediaMobile) ? detailsDataMediaMobile.findIndex(t => t.dataType == dataType) : -1
                const dataChartSerie = {
                    type: 'line',
                    label: traduction,
                    data: dataChart,
                    spanGaps: true,
                    borderWidth: 2,
                    borderColor: [
                        hunaColor,
                    ],
                    pointBackgroundColor: hunaColor,
                    // pointRadius: this.getPointRadius(),
                    // hoverRadius: 0,
                    backgroundColor: stringIsSet(hunaColor) ? hunaColors.colorOpacityHex(hunaColor, 0.3) : undefined,
                    fill: indexDetailsDataMediaMobile >= 0 ? '+1' : undefined,
                    order: 2
                };
                dataSet.push(dataChartSerie);
                if (indexDetailsDataMediaMobile >= 0) {
                    const values = detailsDataMediaMobile[indexDetailsDataMediaMobile]
                    const dataChartSerie = {
                        type: 'line',
                        label: this.translate.instant('mobileMedia') + ' ' + traduction,
                        data: values.data.map((d: any) => ({ x: d.date, y: d.value })),
                        spanGaps: true,
                        borderWidth: 1,
                        borderColor: 'black',
                        pointBackgroundColor: 'black',
                        fill: 'none',
                        backgroundColor: stringIsSet(hunaColor) ? hunaColors.colorOpacityHex(hunaColor, 0.3) : undefined,
                        // pointRadius: this.getPointRadius(1),
                        // hoverRadius: 6,
                        order: 1
                    };
                    dataSet.push(dataChartSerie);

                }


            }
        });


        if (periodLine) {
            let hidden = true;

            dataSet.push({
                type: 'bar',
                label: this.translate.instant('periodsChart'),
                data: periodLine.map(date => ({ x: date, y: maxValue })),
                maxBarThickness: 1,
                backgroundColor: 'red',
                hidden,
                order: 1000

            })
        }
        const date3 = new Date()
        const date2 = new Date(date3.getTime() - 2000)
        const date1 = new Date(date3.getTime() - 4000)
        const d1: any = [{
            backgroundColor: '#FF000040',
            pointBackgroundColor: 'red',
            borderColor: 'red',
            data: [{ x: date1, y: 25 }, { x: date2, y: -20 }, { x: date3, y: 10 }],
            fill: '+1',
        }, {
            pointBackgroundColor: 'green',
            borderColor: 'green',
            data: [{ x: date1, y: 20 }, { x: date2, y: 10 }, { x: date3, y: -10 }]
        }]
        const config = this.chartService.getMixedBarLineTimeAxisChartConfiguration(dataSet, {
            yLabel: undefined,
            xLabel: this.translate.instant('unitOfMeasurement.hour.traduction'),
            chartTitle: ' '
        }, xAxes, undefined, true);
        this.config = config;

    }

    getMediaMobileDetails(detailsData: {
        data: temperatureDetail[],
        dataType: string,
        fromDate: undefined,
        toDate: undefined
    }[], periodMobileMediaMinute: number | undefined) {
        let marginPoints: Date[] | undefined = undefined
        let detailsDataMediaMobile: typeof detailsData = []

        // detailsData.map(d => d.data = d.data.slice(0, 20))
        const maxMinutePeriodDate = detailsData.reduce((max, valuesForDetails) => {
            if (valuesForDetails && arrayIsSet(valuesForDetails.data)) {
                const initDatePeriod = valuesForDetails.data[0].date
                const finishDatePeriod = valuesForDetails.data[valuesForDetails.data.length - 1].date
                const diffDate = finishDatePeriod.getTime() - initDatePeriod.getTime()
                const maxMinutePeriodDate = Math.round(Math.abs(diffDate) / 1000 / 60 / 5)
                if (maxMinutePeriodDate > max) {
                    max = maxMinutePeriodDate
                }
            }

            return max
        }, 0)
        if (periodMobileMediaMinute != null && periodMobileMediaMinute != 0) {

            const periodMobileMediaMilliSec = periodMobileMediaMinute * 60 * 1000
            detailsData.forEach(valuesForDetails => {
                marginPoints = []
                const currentDataType = valuesForDetails.dataType
                let periods: {
                    values: PeriodClass[]
                }[] = []
                if (arrayIsSet(valuesForDetails.data)) {
                    // let initDatePeriod: any
                    let lastIndex = 0
                    let currentPeriod = {
                        values: [] as any,
                    }
                    const correctValueData = valuesForDetails.data
                        .sort((a, b) => a.date.getTime() - b.date.getTime())
                        .filter(value => value.date != null && value.value != null)


                    let initDatePeriod = correctValueData[0].date
                    const finishDatePeriod = correctValueData[correctValueData.length - 1].date

                    const diffDate = finishDatePeriod.getTime() - initDatePeriod.getTime()
                    while (initDatePeriod.getTime() < finishDatePeriod.getTime()) {
                        marginPoints!.push(initDatePeriod)
                        const nextPeriod = new Date(initDatePeriod.getTime() + periodMobileMediaMilliSec);
                        const datesSliceGetTime: number[] = correctValueData
                            .slice(lastIndex, correctValueData.length)
                            .map(values => values.date.getTime())
                        let indexTime = datesSliceGetTime.findIndex(date => date >= initDatePeriod.getTime() && date < nextPeriod.getTime())
                        let lastIndexTime = indexTime
                        if (indexTime >= 0) {
                            lastIndexTime = datesSliceGetTime
                                .slice(indexTime + 1, datesSliceGetTime.length)
                                .findIndex(date => date >= nextPeriod.getTime())
                            if (lastIndexTime >= 0) {
                                lastIndexTime += indexTime + 1
                            }
                        }
                        if (indexTime < 0 && lastIndexTime >= 0) {
                            console.log('error')
                            console.log('error')
                            console.log('error')
                            console.log('error')
                            console.log('error')
                        }


                        if (lastIndexTime < 0 && indexTime >= 0) {
                            const valuesInPeriod = correctValueData
                                .slice(indexTime + lastIndex, indexTime + lastIndex + 1)
                            currentPeriod = {
                                values:
                                    valuesInPeriod
                                        .map((values, index) => {
                                            const nextValues = correctValueData[lastIndex + indexTime + index + 1]
                                            let nextMeasurementDate
                                            if (nextValues) {
                                                nextMeasurementDate = nextValues.date.getTime() > nextPeriod.getTime() ? nextPeriod : nextValues.date
                                            } else {
                                                nextMeasurementDate = nextPeriod;
                                            }
                                            const period = new PeriodClass(values.value, values.date, nextMeasurementDate, initDatePeriod, nextPeriod)
                                            return period
                                        })
                            }
                        } else if (indexTime < 0) {
                            lastIndexTime = 0
                            const c = correctValueData[lastIndex - 1];
                            const period = new PeriodClass(c.value, c.date, nextPeriod, initDatePeriod, nextPeriod)
                            currentPeriod = {
                                values: [period]
                            }
                        } else {

                            const valuesInPeriod = correctValueData
                                .slice(indexTime + lastIndex, lastIndex + lastIndexTime)
                            currentPeriod = {
                                values:
                                    valuesInPeriod
                                        .map((values, index) => {
                                            const nextValues = correctValueData[lastIndex + indexTime + index + 1]

                                            let nextMeasurementDate
                                            if (nextValues) {
                                                nextMeasurementDate = nextValues.date.getTime() > nextPeriod.getTime() ? nextPeriod : nextValues.date
                                            } else {
                                                nextMeasurementDate = nextPeriod;
                                            }
                                            const period = new PeriodClass(values.value, values.date, nextMeasurementDate, initDatePeriod, nextPeriod)
                                            return period
                                        })
                            }
                        }

                        periods.push(currentPeriod)
                        lastIndex += lastIndexTime
                        initDatePeriod = nextPeriod
                    }

                }
                const mediaData: { value: number, date: Date }[] = []
                periods.forEach(period => {
                    let sumWeight = 0
                    let sumValuesWeigth = 0
                    // let sumValues = 0
                    period.values.forEach((v, index) => {
                        // sumValues += v.value
                        sumWeight += v.weigth
                        sumValuesWeigth += v.weigthedValue
                    })
                    let mediaw = sumValuesWeigth / sumWeight
                    const lastValues = period.values[period.values.length - 1]
                    // let media = sumValues / period.values.length
                    mediaData.push({
                        value: mediaw,
                        date: new Date(lastValues.initPeriod.getTime() + periodMobileMediaMilliSec / 2)
                    })

                    // if (Math.round(mediaw * 100) != Math.round(media * 100)) {
                    //     console.log('media  ', media)
                    //     console.log('media w', mediaw)
                    // }

                })

                detailsDataMediaMobile.push({
                    data: mediaData,
                    fromDate: valuesForDetails.fromDate,
                    toDate: valuesForDetails.toDate,
                    dataType: currentDataType,
                })


            })
            return { detailsDataMediaMobile, maxMinutePeriodDate, marginPoints }
        }
        return
    }

    getPointRadius(defaultValue = 2) {
        return 0
    }

    getChartData(temperatureDetails: {
        dataType: string,
        data: temperatureDetail[],
        color: 'orange' | 'yellow' | 'blue' | 'violet',
        name?: string,
        uom?: string,
        scale?: SensorDataScaleType
    }[], detailsDataMediaMobile: any[], periodLine: Date[] | undefined): any {
        let min;
        let max;
        let xAxes;
        const dataSet: any[] = [];
        let maxValue = 0
        const idNoScale = 'y'
        let yScales: any
        const getIdScale = (value: SensorDataScaleType | undefined, uom: string | undefined) => {
            if (value == null) {
                return stringIsSet(uom) ? 'y' + uom : idNoScale
            } else {
                return Object.keys(value).reduce((prev, key) => {
                    if ((value as any)[key] != null && !objectIsSet((value as any)[key])) {
                        prev += key
                        prev += (value as any)[key]
                    }
                    return prev
                }, 'y')
            }
        }
        if (arrayIsSet(temperatureDetails) && temperatureDetails.length > 1) {
            yScales = temperatureDetails.reduce((axis, current, index) => {
                const idScale = getIdScale(current.scale, current.uom)
                if (axis == null || (!(idScale in axis))) {
                    axis[idScale] = {
                        uoms: [],
                        ...current.scale,
                        title: {
                            display: false,
                            text: '',
                        }
                    }
                }
                if (stringIsSet(current.uom) && !axis[idScale].uoms.includes(current.uom)) {
                    if (axis[idScale].title.display) {
                        axis[idScale].title.text += ' - (' + current.uom + ')'
                    } else if (!axis[idScale].title.display) {
                        axis[idScale].title.display = true
                        axis[idScale].title.text = '(' + current.uom + ')'
                    }
                    axis[idScale].uoms.push(current.uom)
                }
                if (index == temperatureDetails.length - 1) {
                    Object.values(axis).forEach((ax: any) => {
                        delete ax.uoms
                    })
                }
                return axis
            }, {} as any)
        }
        temperatureDetails.forEach((temperatureDetail, index) => {
            const dataChart: { x: Date, y: number | undefined }[] = [];
            const dataType = temperatureDetail.dataType;
            const uom = temperatureDetail.uom;
            const scale = temperatureDetail.scale;
            const idScale = getIdScale(scale, temperatureDetail.uom);
            const name = temperatureDetail.name ?? '';
            const color = temperatureDetail.color;
            if (isNotNullOrUndefined(temperatureDetail)) {
                temperatureDetail.data.forEach(
                    temp => {
                        if (temp.value > maxValue) {
                            maxValue = temp.value
                        }
                        if (isNotNullOrUndefined(temp) && isNotNullOrUndefined(temp.value) && isNotNullOrUndefined(temp.date)) {
                            dataChart.push({ x: temp.date, y: temp.value });
                        }

                    }
                );
            }


            if (dataChart.length == 0) {
                const day = new Date();
                day.setHours(0, 0, 0, 0);
                min = day.getTime();
                day.setDate(day.getDate() + 1);
                day.setMilliseconds(-1);
                max = day.getTime();
                xAxes = { min, max, stepSize: 1, type: 'time' };

            }


            if (arrayIsSet(dataChart)) {
                let traduction = this.globalVariableService.instantSensorDataTypeTraduction(dataType, this.translate.currentLang)
                if (!stringIsSet(traduction)) {
                    traduction = ''
                }
                if (stringIsSet(uom)) {
                    (traduction as string) += ' ' + uom
                }
                const yAxisID = yScales != null && idScale in yScales ? idScale : undefined
                const hunaColor = hunaColors[color];
                const indexDetailsDataMediaMobile = arrayIsSet(detailsDataMediaMobile) ? detailsDataMediaMobile.findIndex(t => t.dataType == dataType) : -1
                const dataChartSerie = {
                    type: 'line',
                    label: name + ' ' + traduction,
                    data: dataChart,
                    spanGaps: true,
                    borderWidth: 2,
                    borderColor: hunaColor,
                    pointBackgroundColor: hunaColor,
                    // pointRadius: this.getPointRadius(),
                    // hoverRadius: 0,
                    backgroundColor: stringIsSet(hunaColor) ? hunaColors.colorOpacityHex(hunaColor, 0.3) : undefined,
                    fill: indexDetailsDataMediaMobile >= 0 ? '+1' : undefined,
                    order: 2,
                    yAxisID,
                    objectId: new Date().getTime().toString(32) + index
                };
                dataSet.push(dataChartSerie);
                if (indexDetailsDataMediaMobile >= 0) {
                    const values = detailsDataMediaMobile[indexDetailsDataMediaMobile]
                    const dataChartSerie = {
                        type: 'line',
                        label: this.translate.instant('mobileMedia') + ' ' + traduction,
                        data: values.data.map((d: any) => ({ x: d.date, y: d.value })),
                        spanGaps: true,
                        borderWidth: 1,
                        borderColor: 'black',
                        pointBackgroundColor: 'black',
                        fill: 'none',
                        backgroundColor: stringIsSet(hunaColor) ? hunaColors.colorOpacityHex(hunaColor, 0.3) : undefined,
                        // pointRadius: this.getPointRadius(1),
                        // hoverRadius: 0,
                        order: 1,
                        yAxisID
                    };
                    dataSet.push(dataChartSerie);

                }


            }
        });


        if (periodLine) {
            let hidden = true;

            dataSet.push({
                type: 'bar',
                label: this.translate.instant('periodsChart'),
                data: periodLine.map(date => ({ x: date, y: maxValue })),
                maxBarThickness: 1,
                backgroundColor: 'red',
                borderColor: 'red',
                hidden,
                order: 1000

            })
        }
        const date3 = new Date()
        const date2 = new Date(date3.getTime() - 2000)
        const date1 = new Date(date3.getTime() - 4000)
        const d1: any = [{
            backgroundColor: '#FF000040',
            pointBackgroundColor: 'red',
            borderColor: 'red',
            data: [{ x: date1, y: 25 }, { x: date2, y: -20 }, { x: date3, y: 10 }],
            fill: '+1',
        }, {
            pointBackgroundColor: 'green',
            borderColor: 'green',
            data: [{ x: date1, y: 20 }, { x: date2, y: 10 }, { x: date3, y: -10 }]
        }]
        const config = this.chartService.getMixedBarLineTimeAxisChartConfiguration(dataSet, {
            yLabel: undefined,
            xLabel: this.translate.instant('unitOfMeasurement.hour.traduction'),
            chartTitle: ' '
        }, xAxes, yScales, true);


        // this.getMediaMobileDetails(temperatureDetails,detailsDataMediaMobile,undefined)

        return config;

    }


    getGradientBackGroundColorChart(color: 'violet' | 'yellow' | 'orange' | 'verdeBlue' | 'blue', typeChart: 'bar' | 'linear') {
        let color1;
        let color2;
        let color3;
        let color4;
        const scaleOpacity = [];
        if (typeChart === 'bar') {
            scaleOpacity.push(1);
            scaleOpacity.push(0.8);
            scaleOpacity.push(0.5);
            scaleOpacity.push(0.3);
        } else {
            scaleOpacity.push(1);
            scaleOpacity.push(0.8);
            scaleOpacity.push(0.1);
            scaleOpacity.push(0.0);
        }
        if (color === 'violet') {
            color1 = hunaColors.violetOpacity(scaleOpacity[0]);
            color2 = hunaColors.violetOpacity(scaleOpacity[1]);
            color3 = hunaColors.violetOpacity(scaleOpacity[2]);
            color4 = hunaColors.violetOpacity(scaleOpacity[3]);
        } else if (color == 'yellow') {
            color1 = hunaColors.yellowOpacity(scaleOpacity[0]);
            color2 = hunaColors.yellowOpacity(scaleOpacity[1]);
            color3 = hunaColors.yellowOpacity(scaleOpacity[2]);
            color4 = hunaColors.yellowOpacity(scaleOpacity[3]);
        } else if (color == 'verdeBlue') {
            color1 = hunaColors.verdeBlueOpacity(scaleOpacity[0]);
            color2 = hunaColors.verdeBlueOpacity(scaleOpacity[1]);
            color3 = hunaColors.verdeBlueOpacity(scaleOpacity[2]);
            color4 = hunaColors.verdeBlueOpacity(scaleOpacity[3]);
        } else if (color == 'blue') {
            color1 = hunaColors.blueOpacity(scaleOpacity[0]);
            color2 = hunaColors.blueOpacity(scaleOpacity[1]);
            color3 = hunaColors.blueOpacity(scaleOpacity[2]);
            color4 = hunaColors.blueOpacity(scaleOpacity[3]);
        } else {
            color1 = hunaColors.orangeOpacity(scaleOpacity[0]);
            color2 = hunaColors.orangeOpacity(scaleOpacity[1]);
            color3 = hunaColors.orangeOpacity(scaleOpacity[2]);
            color4 = hunaColors.orangeOpacity(scaleOpacity[3]);
        }
        const ctx = document.createElement('canvas');
        const gradient = ctx.getContext('2d')!.createLinearGradient(0, 0, 0, 400);
        gradient.addColorStop(0.2, color1);
        gradient.addColorStop(0.3, color2);
        gradient.addColorStop(0.4, color3);
        gradient.addColorStop(1, color4);
        return gradient;
    }


    getColorButton(key: string,): 'accent' | 'primary' | 'violet' | 'yellow' | 'unset-color' {
        if (this.keyIsInDataTypes(key) && this.colorDataType[key]) {
            if (this.colorDataType[key] === 'orange') {
                return 'accent';
            } else if (this.colorDataType[key] === 'blue') {
                return 'primary';
            } else {
                return this.colorDataType[key] as 'violet' | 'yellow';
            }
        } else {
            return 'unset-color';
        }
    }

    getColorButtonByColors(key: string, elementId: string, getId: any, colors: KeyStringValue<string>, dataTypes: {
        dataType: string,
        elementId: string
    }[] | undefined): 'accent' | 'primary' | 'violet' | 'yellow' | 'unset-color' {
        const idType = getId(key, elementId);
        const iseSet = () => {
            if (arrayIsSet(dataTypes)) {
                const index = dataTypes.findIndex(type => getId(type.dataType, type.elementId) == idType);
                return index >= 0;
            } else {
                return false;
            }
        }
        if (iseSet() && colors[idType]) {
            if (colors[idType] === 'orange') {
                return 'accent';
            } else if (colors[idType] === 'blue') {
                return 'primary';
            } else {
                return colors[idType] as 'violet' | 'yellow';
            }
        } else {
            return 'unset-color';
        }
    }

    getIsSelected(key: string, elementId: string, getId: any, colors: KeyStringValue<string>, dataTypes: {
        dataType: string,
        elementId: string
    }[] | undefined): boolean {
        const idType = getId(key, elementId);
        const iseSet = () => {
            if (arrayIsSet(dataTypes)) {
                const index = dataTypes.findIndex(type => getId(type.dataType, type.elementId) == idType);
                return index >= 0;
            } else {
                return false;
            }
        }
        return iseSet() && colors[idType] != null
    }

    // _deltaDate: any = {}
    // _lastRangeDate: any = {}

    // changeCalendar(event: { start: Date, end: Date }) {
    //     let start = event.start;
    //     let end = event.end;
    //     const deltDate = end.getTime() - start.getTime();
    //     const millisecInDay = 1 * 24 * 3600 * 1000;
    //     this._deltaDate[this.form.get('dataType')?.value] = Math.round(deltDate / millisecInDay) - 1;
    //     const rangeDate: rangeDate = {fromDate: start, toDate: end};
    //     this.dateChangedTemperature(rangeDate)
    // }


    // get lastRange() {
    //     if (this.form.get('range')?.value != null) {
    //         return this.form.get('range')?.value
    //     } else {
    //         const beforSevenDay = new Date();
    //         const deltaDate = this.deltaDate ? this.deltaDate : 7;
    //         beforSevenDay.setDate(this.lastDate.getDate() - deltaDate);
    //         return {fromDate: beforSevenDay, toDate: this.lastDate}
    //     }
    // }

    // getLastRangeByDataType(dataType: string) {
    //     if (this._lastRangeDate[dataType] != null) {
    //         return this._lastRangeDate[dataType]
    //     } else {
    //         return this.lastRange
    //     }
    // }

    // public get deltaDate(): number {
    //     if (this._deltaDate[this.form.get('dataType')?.value] != null) {
    //         return this._deltaDate[this.form.get('dataType')?.value]
    //     } else {
    //         return 7
    //     }
    // }


    // changeDateStart(event: Date | null) {
    //     const start = event;
    //     if (isNotNullOrUndefined(start) && this.form.get('range')?.value) {
    //         const range = this.form.get('range')?.value
    //         range.fromDate = event
    //         this.form.get('range')?.setValue(range, {emitEvent: false});
    //     }
    // }
    //
    // changeDateEnd(event: Date | null) {
    //     const end = event;
    //     if (isNotNullOrUndefined(end) && this.form.get('range')?.value != null) {
    //         const range = this.form.get('range')?.value
    //         range.toDate = event
    //         this.dateChangedTemperature(range)
    //     }
    // }

    keyIsInDataTypes(dataType: string): boolean {
        if (this.form.get('dataType') && arrayIsSet(this.form.get('dataType')?.value)) {
            return this.keyIsInDataTypesByDataTapes(dataType, this.form.get('dataType')?.value)
        } else {
            return false;
        }
    }

    keyIsInDataTypesByDataTapes(dataType: string, dataTypes: string[] | undefined): boolean {
        if (arrayIsSet(dataTypes)) {
            const index = dataTypes.findIndex(type => type == dataType);
            return index >= 0;
        } else {
            return false;
        }
    }

    getIdDataType(dataType: string, elementId: string) {
        return elementId + dataType
    }

    clickDataType(dataType: string, emit = true): void {
        let dataTypeToSet = [];
        let updateColor = true;
        const colorsDataType = objectIsSet(this.colorDataType) ? { ...this.colorDataType } : {};
        if (!(arrayIsSet(this.form.get('dataType')?.value) && this.form.get('dataType')?.value.length == 1 && this.form.get('dataType')?.value.includes(dataType))) {
            if (this.form.get('dataType') && arrayIsSet(this.form.get('dataType')?.value)) {
                const dataTypes = [...this.form.get('dataType')?.value];
                const index = dataTypes.findIndex(type => type === dataType);
                if (index >= 0) {
                    if (dataTypes.length > 1) {
                        const value = dataTypes.splice(index, 1);
                        delete colorsDataType[value[0]];
                        updateColor = false;
                    }
                } else if (dataTypes.length >= 4) {
                    const value = dataTypes.splice(0, 1);
                    delete colorsDataType[value[0]];
                    dataTypes.push(dataType);
                } else {
                    dataTypes.push(dataType);
                }
                dataTypeToSet = dataTypes;
            } else {
                dataTypeToSet = [dataType];
            }
            if (updateColor) {
                const colors: ['orange', 'yellow', 'blue', 'violet'] = ['orange', 'yellow', 'blue', 'violet'];
                const utilizedColors = Object.values(colorsDataType);
                const noUtilizedColor = colors.filter(color => !utilizedColors.includes(color));
                let colorAssign;
                const colorDataType = (DataTypeColor as any)[dataType];
                if (arrayIsSet(noUtilizedColor)) {
                    colorAssign = noUtilizedColor[0];
                    if (stringIsSet(colorDataType)) {
                        const index = noUtilizedColor.findIndex(c => c === colorDataType)
                        if (index >= 0) {
                            colorAssign = noUtilizedColor[index];
                        }
                    }
                } else {
                    colorAssign = colors[0];
                    if (stringIsSet(colorDataType)) {
                        const index = colors.findIndex(c => c === colorDataType)
                        if (index >= 0) {
                            colorAssign = colors[index];
                        }
                    }
                }
                colorDataType[dataType] = colorAssign
            }
            // console.log("dataType", this.colorDataType[dataType]);
            this.colorDataType = colorsDataType;
            this.form.get('dataType')?.setValue(dataTypeToSet, { emitEvent: emit });
        }
    }


    clickDataTypeInElements(dataType: string, elementId: string, emit = true): void {
        let dataTypeToSet: DataTypeDetail[] = [];
        let updateColor = true;
        const dataTypeSelected = this.form.get('dataType')?.value
        const idDataType = this.getIdDataType(dataType, elementId)
        const colorsDataType = objectIsSet(this.colorDataType) ? { ...this.colorDataType } : {};
        if (!this.downloadModeIsActive) {
            if (!(arrayIsSet(dataTypeSelected) && dataTypeSelected.length == 1 && dataTypeSelected.some((type: any) => this.getIdDataType(type.dataType, type.elementId) == idDataType))) {
                if (arrayIsSet(dataTypeSelected)) {
                    const dataTypes: DataTypeDetail[] = [...dataTypeSelected as any[]];
                    const index = dataTypes.findIndex(type => this.getIdDataType(type.dataType, type.elementId) === idDataType);
                    if (index >= 0) {
                        if (dataTypes.length > 1) {
                            const value = dataTypes.splice(index, 1);
                            delete colorsDataType[this.getIdDataType(value[0].dataType, value[0].elementId)];
                            updateColor = false;
                        }
                    } else if (dataTypes.length >= 4) {
                        const value = dataTypes.splice(0, 1);
                        delete colorsDataType[this.getIdDataType(value[0].dataType, value[0].elementId)];
                        dataTypes.push({ elementId, dataType });
                    } else {
                        dataTypes.push({ elementId, dataType });
                    }
                    dataTypeToSet = dataTypes;
                } else {
                    dataTypeToSet = [{ elementId, dataType }];
                }
                if (updateColor) {
                    const colors: ['orange', 'yellow', 'blue', 'violet'] = ['orange', 'yellow', 'blue', 'violet'];
                    const utilizedColors = Object.values(colorsDataType);
                    const noUtilizedColor = colors.filter(color => !utilizedColors.includes(color));
                    let colorAssign;
                    const colorDataType = (DataTypeColor as any)[idDataType];
                    if (arrayIsSet(noUtilizedColor)) {
                        colorAssign = noUtilizedColor[0];
                        if (stringIsSet(colorDataType)) {
                            const index = noUtilizedColor.findIndex(c => c === colorDataType)
                            if (index >= 0) {
                                colorAssign = noUtilizedColor[index];
                            }
                        }
                    } else {
                        colorAssign = colors[0];
                        if (stringIsSet(colorDataType)) {
                            const index = colors.findIndex(c => c === colorDataType)
                            if (index >= 0) {
                                colorAssign = colors[index];
                            }
                        }
                    }
                    colorsDataType[idDataType] = colorAssign
                }
                this.colorDataType = colorsDataType
                this.form.get('dataType')?.setValue(dataTypeToSet, { emitEvent: emit });
            }
        } else {
            const index = this.selectedInDownloadMode.findIndex(sel => this.getIdDataType(sel.dataType, sel.elementId) == idDataType)
            if (index >= 0) {
                this.selectedInDownloadMode.splice(index, 1)
            } else {
                this.selectedInDownloadMode.push({ dataType, elementId })
            }
        }

        this.colorDataType = colorsDataType
        this.hiddenLegends = undefined
    }

    getColorButtonElement(dataType: string, elementId: string): 'accent' | 'primary' | 'violet' | 'yellow' | 'unset-color' {
        const id = this.getIdDataType(dataType, elementId)
        if (this.colorDataType[id]) {
            if (this.colorDataType[id] === 'orange') {
                return 'accent';
            } else if (this.colorDataType[id] === 'blue') {
                return 'primary';
            } else {
                return this.colorDataType[id] as 'violet' | 'yellow';
            }
        } else if (arrayIsSet(this.selectedInDownloadMode)) {
            return this.selectedInDownloadMode.find(sel => this.getIdDataType(sel.dataType, sel.elementId) == id) != null ? 'primary' : 'unset-color'
        } else {
            return 'unset-color';
        }
    }

    get breakPointFilterTable(): breakPointType[] {
        return [
            {
                maxWidth: 1000,
                sx: { percent: undefined, px: 300 },
                dx: { percent: undefined, px: undefined },
            }, {
                maxWidth: 650,
                sx: { percent: 100, px: undefined },
                dx: { percent: 100, px: undefined },
            }
        ];
    }

    openChartFull(chart: any | undefined): void {
        if (chart != undefined) {
            this.chartService.openChartFull(chart!, this.getName(undefined));
        } else {
            const message = this.translate.instant('noData');
            this.alertService.warning(message);
        }
    }


    downloadChart(chart: any | undefined = undefined): void {
        this.configChart$.pipe(
            take(1),
            map(values => {
                const transformDate = (date: Date) => {
                    let value = ''
                    if (date.getDate) {
                        value += date.getDate() + '/'
                    }
                    if (date.getMonth) {
                        value += (date.getMonth() + 1) + '/'
                    }
                    if (date.getFullYear) {
                        value += date.getFullYear() + ' '
                    }
                    if (date.getHours) {
                        value += (date.getHours() + '').padStart(2, '0')
                    }
                    if (date.getMinutes) {
                        value += ':' + (date.getMinutes() + '').padStart(2, '0')
                    }
                    if (date.getSeconds) {
                        value += ':' + (date.getSeconds() + '').padStart(2, '0')
                    }
                    return value
                }
                const datasets = values.data.datasets;
                const allXvalues: number[] = datasets.reduce((prev: number[], dataset: any, index: number) => {
                    if (arrayIsSet(dataset.data)) {
                        prev = prev.concat(dataset.data.map((v: any) => v.x))
                    }
                    if (index == datasets.length - 1) {
                        prev = [...new Set(prev)]
                        prev
                            .filter(a => a != null)
                    }
                    return prev
                }, [] as number[])
                const keysFixed: string[] = ['date', 'year', 'month', 'day', 'hour', 'minute', 'second',]
                const keysLabels: string[] = []
                datasets.forEach((data: any) => {
                    keysLabels.push(data.label)
                })
                let rows
                if (arrayIsSet(allXvalues)) {
                    rows = allXvalues
                        .sort((a, b) => a - b)
                        .reduce((prev: string[][], dateTime: number) => {
                            const date = new Date(dateTime)
                            const year = date.getFullYear()
                            const month = date.getMonth()
                            const day = date.getDate()
                            const hour = date.getHours()
                            const minute = date.getMinutes()
                            const second = date.getSeconds()
                            const completDate = transformDate(date)
                            const row: string[] = [completDate, year.toString(), month.toString(), day.toString(), hour.toString(), minute.toString(), second.toString()]
                            datasets.forEach((dataset: any) => {
                                let value = ''
                                if (arrayIsSet(dataset.data)) {
                                    const index = dataset.data.findIndex((value: any) => {
                                        return value.x == dateTime
                                    })
                                    if (index >= 0) {
                                        value = dataset.data[index].y
                                    }
                                }
                                row.push(value)
                            })

                            prev.push(row)
                            return prev
                        }, [keysFixed.concat(keysLabels)])
                }
                return rows
            })
        ).subscribe(rows => {
            if (rows != null) {
                const getFileName = () => {
                    const types = this.form.get('dataType')?.value as any[];
                    const projectName = this.data.projectName;
                    const device = this.data.device;
                    let value = ''
                    if (stringIsSet(projectName)) {
                        value += projectName + '_'
                    }
                    if (device && stringIsSet(device.name)) {
                        value += device.name + '_'
                    }
                    if (arrayIsSet(types)) {
                        value += types.reduce((prev, type: any, index) => {
                            const trad = this.globalVariableService.instantSensorDataTypeTraduction(type.dataType, this.translate.currentLang)
                            prev += trad!;
                            if (index < types.length - 1) {
                                prev += '_';
                            }
                            return prev
                        }, '')
                    }
                    return stringIsSet(value) ? value : 'chart';
                }
                this.exportFile.downloadFile(rows, getFileName());

            }
        })

    }


    getName(key: string | undefined): string {
        const today = new Date();
        if (key != null) {
            return this.translate.instant(key) + ' ' + this.data.projectName + ' ' + today.getHours() + ':' + today.getMinutes();
        } else {
            return this.data.projectName + ' ' + today.getHours() + ':' + today.getMinutes();
        }
    }

    downloadChartImage(chart: any | undefined, key: string | undefined): void {
        if (chart != null) {
            const fileName = this.getName(key);
            this.chartService.getImageChart(chart, 1).subscribe(image => {
                if (image != null) {
                    this.exportFile.openLink(image, fileName + '.png');
                }
            });
        }
    }


    get deltaDateHourlyCurve(): number {
        if (this._deltaDate.hourlyCurve != null) {
            return this._deltaDate.hourlyCurve;
        } else {
            return 1;
        }
    }

    setDeltaDateHourlyCurve(value: rangeDate): void {
        if (value.fromDate && value.toDate) {
            const fromDateTime = value.fromDate.getTime()
            const toDateTime = value.toDate.getTime()
            const millisecInDay = 1 * 24 * 3600 * 1000;
            const deltDate = fromDateTime - toDateTime;
            this._deltaDate['hourlyCurve'] = Math.abs(Math.round(deltDate / millisecInDay));
        }
    }

    setChart(chart: any) {
        this.chartTemperature = chart
    }

    closeDialog() {
        this.destroyChart(this.chartTemperature);
        this.dialogRef.close()
    }

    resetZoom() {
        this.chartTemperature.resetZoom()
    }

    unsetKey(key: string) {
        this.form.get(key)?.reset()
    }

    predicateFiler(node: ElementNode, searchName: string | undefined) {
        if (stringIsSet(searchName)) {
            const cleanSearchName = cleanToSpecialCharacterAndLowerCaseString(searchName)
            const cleanEnvironmentName = cleanToSpecialCharacterAndLowerCaseString(node.environment)
            let block = cleanEnvironmentName.includes(cleanSearchName)
            if (!(block)) {
                const cleanSearchName = cleanToSpecialCharacterAndLowerCaseString(searchName)
                const cleanName = cleanToSpecialCharacterAndLowerCaseString(node.name)
                block = cleanName.includes(cleanSearchName)
            }
            if (!(block)) {
                const cleanSearchName = cleanToSpecialCharacterAndLowerCaseString(searchName)
                const cleanParentName = cleanToSpecialCharacterAndLowerCaseString(node.parentName)
                block = cleanParentName.includes(cleanSearchName)
            }

            if (!(block) && arrayIsSet(node.children)) {
                block = node.children.some(n => {
                    const cleanParentName = cleanToSpecialCharacterAndLowerCaseString(n.parentName)
                    const cleanName = cleanToSpecialCharacterAndLowerCaseString(n.name)
                    return cleanParentName.includes(searchName) || cleanName.includes(searchName)
                })
            }
            return block ? undefined : ['hidden']
        }
        return undefined
    }

    clickDownloadMode() {
        this.downloadModeIsActive = !this.downloadModeIsActive
        this.selectedInDownloadMode = []

    }

    getDataPaginate(allValues: DataTypeDetail[]) {
        const fetchPage$ = (page = 0) => {


            const current = allValues[page];

            const isLast = (page + 1) >= allValues.length;
            const progress = Math.ceil((page + 1) / allValues.length * 100)
            return this.getDataTypeDetail_v2(current.elementId, current.dataType, this.form.get('range')!.value).pipe(
                map(values => {
                    return {
                        item: values,
                        progress,
                        nextPage: isLast ? undefined : (page + 1),
                        finished: isLast,
                    }
                }),
                catchError(error => {
                    return of({
                        item: undefined,
                        progress,
                        nextPage: isLast ? undefined : (page + 1),
                        finished: isLast,
                        error
                    })
                })
            )
        }
        return fetchPage$(0).pipe(
            expand(({ nextPage }) => nextPage ? fetchPage$(nextPage) : EMPTY)
        )
    }

    clickDownloadChart() {
        this.downloadingFile = { active: true, progress: 0 }
        const transformDate = (date: Date) => {
            let value = ''
            if (date.getDate) {
                value += date.getDate() + '/'
            }
            if (date.getMonth) {
                value += (date.getMonth() + 1) + '/'
            }
            if (date.getFullYear) {
                value += date.getFullYear() + ' '
            }
            if (date.getHours) {
                value += (date.getHours() + '').padStart(2, '0')
            }
            if (date.getMinutes) {
                value += ':' + (date.getMinutes() + '').padStart(2, '0')
            }
            if (date.getSeconds) {
                value += ':' + (date.getSeconds() + '').padStart(2, '0')
            }
            return value
        }
        const getDateTime = (date: Date) => {
            const tempDate = new Date(date);
            tempDate.setMilliseconds(0);
            return tempDate.getTime()
        }
        const allValues = this.selectedInDownloadMode.concat(this.form.get('dataType')?.value)
        let values: DataTypeDetail[] = []

        this.getDataPaginate(allValues).subscribe(value => {
            if (value.item) {
                values.push(value.item)
            }
            this.downloadingFile = { active: !value.finished, progress: value.progress }
            if (value.finished) {
                const mapValues = new Map<string, KeyStringValue<{ value: number, date: Date, indexLabel: number }>>
                const keysFixed: string[] = ['date', 'year', 'month', 'day', 'hour', 'minute', 'second',]
                const keysLabels: string[] = []
                values.forEach((dataset: DataTypeDetail, indexLabel) => {
                    const element = this.treeControl.dataNodes.find(d => d.elementId == dataset.elementId)
                    let name;
                    if (element != null) {
                        name = element.name
                    } else {
                        name = this.translate.instant('NaN');
                    }
                    keysLabels.push(name + ' ' + this.globalVariableService.instantSensorDataTypeTraduction(dataset.dataType, this.translate.currentLang))
                    dataset.values.data.forEach((v: any) => {
                        const dateTime = getDateTime(v.date).toString()
                        const current = mapValues.has(dateTime) ? mapValues.get(dateTime)! : {}
                        current[this.getIdDataType(dataset.dataType, dataset.elementId)] = {
                            ...v,
                            element,
                            indexLabel: keysFixed.length + indexLabel
                        }
                        mapValues.set(dateTime, current)
                    })
                })
                const getEmptyRow = () => {
                    let i = 0
                    const row: string[] = []
                    while (i < keysFixed.length + keysLabels.length) {
                        row.push('')
                        i++;
                    }
                    return row
                }
                const rows = [keysFixed.concat(keysLabels)]
                for (const key of Array.from(mapValues.keys()).sort((a, b) => parseInt(a) - parseInt(b))) {
                    const dateTimeValue = mapValues.get(key)!;
                    const values = Object.values(dateTimeValue)
                    const date = new Date(values[0].date)
                    const year = date.getFullYear()
                    const month = date.getMonth() + 1
                    const day = date.getDate()
                    const hour = date.getHours()
                    const minute = date.getMinutes()
                    const second = date.getSeconds()
                    const completDate = transformDate(date)
                    const row: string[] = getEmptyRow()
                    row[0] = completDate;
                    row[1] = year.toString();
                    row[2] = month.toString();
                    row[3] = day.toString();
                    row[4] = hour.toString();
                    row[5] = minute.toString();
                    row[6] = second.toString();
                    values.forEach(value => row[value.indexLabel] = value.value.toString())
                    rows.push(row)
                }


                const getFileName = () => {
                    const projectName = this.data.projectName;
                    const device = this.data.device;
                    let value = ''
                    if (stringIsSet(projectName)) {
                        value += projectName + '_'
                    }
                    if (device && stringIsSet(device.name)) {
                        value += device.name + '_'
                    }
                    return stringIsSet(value) ? value : 'chart';
                }
                this.exportFile.downloadFile(rows, getFileName());
                // }
                this.clickDownloadMode()
                this.downloadingFile = { active: false, progress: 0 }
            }


        }, error => {
            this.alertService.error(error)
            this.downloadingFile = { active: false, progress: 0 }

        })

    }

    getElementsPredicate(elements: ElementTreeType[]): ChipsElementsForm[] {
        return elements
            .reduce((prev, el) => {
                if (arrayIsSet(el.recentSensorData)) {
                    if (prev == null) {
                        prev = []
                    }
                    prev.push({
                        elementId: el.objectId,
                        name: el.name,
                        info: el.recentSensorData?.map((values) => {
                            const key = values.type
                            return {
                                key,
                                objectId: this.getIdDataType(key, el.objectId)
                            }
                        }
                        ),
                    })
                }
                return prev
            }, undefined as any)
    }

    enableDisableLegend(index: number, objectId: string) {
        const legends = arrayIsSet(this.hiddenLegends) ? [...this.hiddenLegends] : []
        const indexInarray = legends.findIndex(l => l.index == index)
        if (indexInarray >= 0) {
            legends.splice(indexInarray, 1)
        } else {
            legends.push({ index, objectId })
        }
        this.hiddenLegends = legends
    }

    activeIndex: any

    setTooltip(event: any) {
        if (this.chartTemperature) {
            this.activeIndex = [{
                datasetIndex: 0,
                index: event,
            }]
        }
    }
}

